import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import PageLayout from "./PageLayout";
type FeaturePageLayoutProps = {
  title: string;
  subtitle: string;
  description: string;
  icon: ReactNode;
  children: ReactNode;
  bgColor?: string;
  ctaText?: string;
  ctaLink?: string;
  secondaryCtaText?: string;
  secondaryCtaLink?: string;
};
export const FeaturePageLayout = ({
  title,
  subtitle,
  description,
  icon,
  children,
  bgColor = "bg-gradient-to-r from-primary to-primary-700",
  ctaText,
  ctaLink,
  secondaryCtaText,
  secondaryCtaLink
}: FeaturePageLayoutProps) => {
  return <PageLayout title={title} hideIcon hideHeader={true} // Add this to hide the default header
  >
      <div>
        {/* Hero Section */}
        <div className={`${bgColor} text-white py-20`}>
          <div className="container mx-auto px-4">
            <div className="flex flex-col items-center text-center">
              <div className="p-3 bg-white/20 rounded-full mb-6">
                {icon}
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">{title}</h1>
              <p className="text-xl mb-4 max-w-3xl mx-auto">{subtitle}</p>
              
              
              {(ctaText || secondaryCtaText) && <div className="flex flex-col sm:flex-row gap-4 mt-6">
                  {ctaText && ctaLink && <Button size="lg" className="bg-white text-primary hover:bg-white/90" asChild>
                      
                    </Button>}
                  
                  {secondaryCtaText && secondaryCtaLink && <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" asChild>
                      
                    </Button>}
                </div>}
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="container mx-auto px-4 py-16">
          {children}
        </div>
      </div>
    </PageLayout>;
};